import { ProjectHttpClient } from '../../common/services/httpClient';

export const getKPIs = async (projectId) => {
  const response = await ProjectHttpClient.get(
    `projects/${projectId}/key-performance-indicators`
  );
  return response.data.sections;
};
